import React, { useState } from "react";
import { Button, Modal, Space, Spin, message } from "antd";
import {
  FaFileDownload,
  FaEye,
  FaCloudUploadAlt,
  FaSave,
} from "react-icons/fa";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import {
  uploadPdfToS3,
  getComplianceInfo,
} from "../../../redux/slice/hrFormSlice";
import signatureImage from "../../../../assets/employer_sign.png";

// Import your PDF template
import formTemplate from "../../../../assets/Compliance_FORM.pdf";

const PdfCompliance = ({ formData, jwt_payload_group, jwtBearer }) => {
  console.log("formData", formData);

  const [pdfUrl, setPdfUrl] = useState(null);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [loadingPreview, setLoadingPreview] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [loadingUpload, setLoadingUpload] = useState(false);

  const dispatch = useDispatch();

  const drawCheckmark = (page, x, y) => {
    page.drawLine({
      start: { x: x - 3, y: y + 1 },
      end: { x: x, y: y - 2 },
      thickness: 1.2,
      color: rgb(0, 0, 0),
    });
    page.drawLine({
      start: { x: x, y: y - 2 },
      end: { x: x + 5, y: y + 3 },
      thickness: 1.2,
      color: rgb(0, 0, 0),
    });
  };

  const CHECKMARK_POSITIONS = {
    maritalStatus: {
      MARRIED: { x: 150, y: 478 },
      UNMARRIED: { x: 203, y: 478 },
      WIDOW: { x: 255, y: 478 },
      WIDOWER: { x: 255, y: 478 },
      DIVORCEE: { x: 255, y: 478 },
    },
    gender: {
      MALE: { x: 115, y: 505 },
      FEMALE: { x: 168, y: 505 },
      OTHER: { x: 223, y: 505 },
    },
  };

  const fillPdfForm = async () => {
    try {
      const existingPdfBytes = await fetch(formTemplate).then((res) =>
        res.arrayBuffer()
      );
      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      const pages = pdfDoc.getPages();

      if (pages.length < 5) {
        throw new Error("PDF template does not have all required pages");
      }

      const page1 = pages[0];
      const page2 = pages[1];
      const page3 = pages[2];
      const page4 = pages[3];
      const page5 = pages[4];
      const page6 = pages[5];
      const page7 = pages[6];

      const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
      const helveticaBold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

      const textOptions = {
        size: 8,
        font: helveticaFont,
        color: rgb(0, 0, 0),
      };

      const signatureImageBytes = await fetch(signatureImage).then((res) =>
        res.arrayBuffer()
      );
      const signatureImageEmbed = await pdfDoc.embedPng(signatureImageBytes);


      // console.log("signatureImageEmbed",signatureImageEmbed)
      // page1.drawImage(signatureImageEmbed, {
      //   x: 340,
      //   y: 272,
      //   width: 100,
      //   height: 40,
      // });

      // ===== PAGE 1: FORM 2 REVISED =====
      // page1.drawText(formData.section1?.name?.toUpperCase() || "", {
      //   x: 202,
      //   y: 660,
      //   size: 6,
      //   font: helveticaFont,
      //   color: rgb(0, 0, 0),
      // });

     // ===== PAGE 1: FORM 2 REVISED =====
      page1.drawText(formData.section1?.name?.toUpperCase() || "", {
        x: 272,
        y: 706,
        size: 9,
        font: helveticaFont,
        color: rgb(0, 0, 0),
      });



      page1.drawText(formData.section1?.fatherName1?.toUpperCase() || "", {
        x: 272,
        y: 684,
        size: 9,
        font: helveticaFont,
        color: rgb(0, 0, 0),
      });

      page1.drawText(formData.section1?.dob?.toUpperCase() || "", {
        x: 272,
        y: 661,
        size: 9,
        font: helveticaFont,
        color: rgb(0, 0, 0),
      });

      page1.drawText(formData.section1?.Kyc || "", {
        x: 272,
        y: 591,
        size: 9,
        font: helveticaFont,
        color: rgb(0, 0, 0),
      });

      page1.drawText(formData.section1?.gender || "", {
        x: 272,
        y: 638,
        size: 9,
        font: helveticaFont,
        color: rgb(0, 0, 0),
      });

      page1.drawText(formData.section1?.maritalStatus || "", {
        x: 272,
        y: 614,
        size: 9,
        font: helveticaFont,
        color: rgb(0, 0, 0),
      });

      page1.drawText(formData.section1?.addressTemp?.toUpperCase() || "", {
        x: 272,
        y: 524,
        size: 8,
        font: helveticaFont,
        color: rgb(0, 0, 0),
        maxWidth: 300,
        lineHeight: 15,
      });
      page1.drawText(formData.section1?.addressPerma?.toUpperCase() || "", {
        x: 272,
        y: 569,
        size: 8,
        font: helveticaFont,
        color: rgb(0, 0, 0),
        maxWidth: 300,
        lineHeight: 15,
      });

        page1.drawText(formData.section1?.dojDate?.toUpperCase() || "", {
          x: 288,
        y: 479,
        size: 9,
        font: helveticaFont,
        color: rgb(0, 0, 0),
        maxWidth: 300,
        lineHeight: 15,
      });

      // EPF Nominee Data
     
// if (formData.section1?.epfNomineeData?.length > 0) {
//   const startY = 300;
//   const rowSpacing = 40; 
//   const fieldFontSize = 6; 

//   formData.section1.epfNomineeData.slice(0, 6).forEach((nominee, index) => {
//     const yPos = startY - index * rowSpacing;


//     // Name
//     page1.drawText(nominee.name?.toUpperCase() || "", {
//       x: 55,
//       y: yPos,
//       size: fieldFontSize,
//       font: helveticaFont,
//       color: rgb(0, 0, 0),
//     });

//     // Address
//     page1.drawText(nominee.address?.toUpperCase() || "", {
//       x: 120,
//       y: yPos,
//       size: fieldFontSize,
//       font: helveticaFont,
//       color: rgb(0, 0, 0),
//       maxWidth: 80,
//       lineHeight: 6,
//     });

//     // Relationship
//     page1.drawText(nominee.relationship?.toUpperCase() || "", {
//       x: 230,
//       y: yPos,
//       size: fieldFontSize,
//       font: helveticaFont,
//       color: rgb(0, 0, 0),
//     });

//     // Date of Birth
//     page1.drawText(nominee.dob || "", {
//       x: 300,
//       y: yPos,
//       size: fieldFontSize,
//       font: helveticaFont,
//       color: rgb(0, 0, 0),
//     });

//     // Share %
//     page1.drawText(nominee.share || "", {
//       x: 385,
//       y: yPos,
//       size: fieldFontSize,
//       font: helveticaFont,
//       color: rgb(0, 0, 0),
//     });

//     // Guardian
//     page1.drawText(nominee.guardian || "", {
//       x: 470,
//       y: yPos,
//       size: fieldFontSize,
//       font: helveticaFont,
//       color: rgb(0, 0, 0),
//     });
//   });
// }

if (formData.section1?.epfNomineeData?.length > 0) {
  const startY = 300;
  const rowSpacing = 30;
  const fieldFontSize = 6;

  formData.section1.epfNomineeData.slice(0, 6).forEach((nominee, index) => {
    const yPos = startY - index * rowSpacing;

    // Function to wrap text manually
    const wrapText = (text, maxWidth, font, size) => {
      if (!text) return [""];
      const words = text.split(" ");
      const lines = [];
      let currentLine = "";

      for (const word of words) {
        const testLine = currentLine ? currentLine + " " + word : word;
        const textWidth = font.widthOfTextAtSize(testLine, size);
        if (textWidth > maxWidth && currentLine) {
          lines.push(currentLine);
          currentLine = word;
        } else {
          currentLine = testLine;
        }
      }
      lines.push(currentLine);
      return lines;
    };

    // Wrap the name if too long
    const nameLines = wrapText(nominee.name?.toUpperCase() || "", 60, helveticaFont, fieldFontSize);

    // Draw each line (stacked vertically)
    nameLines.forEach((line, lineIndex) => {
      page1.drawText(line, {
        x: 48,
        y: yPos - lineIndex * (fieldFontSize + 2),
        size: fieldFontSize,
        font: helveticaFont,
        color: rgb(0, 0, 0),
      });
    });

    // Address
    page1.drawText(nominee.address?.toUpperCase() || "", {
      x: 120,
      y: yPos,
      size: fieldFontSize,
      font: helveticaFont,
      color: rgb(0, 0, 0),
      maxWidth: 80,
      lineHeight: 6,
    });

    // Relationship
    page1.drawText(nominee.relationship?.toUpperCase() || "", {
      x: 230,
      y: yPos,
      size: fieldFontSize,
      font: helveticaFont,
      color: rgb(0, 0, 0),
    });

    // Date of Birth
    page1.drawText(nominee.dob || "", {
      x: 300,
      y: yPos,
      size: fieldFontSize,
      font: helveticaFont,
      color: rgb(0, 0, 0),
    });

    // Share %
    page1.drawText(nominee.share || "", {
      x: 385,
      y: yPos,
      size: fieldFontSize,
      font: helveticaFont,
      color: rgb(0, 0, 0),
    });

    // Guardian
    page1.drawText(nominee.guardian || "", {
      x: 470,
      y: yPos,
      size: fieldFontSize,
      font: helveticaFont,
      color: rgb(0, 0, 0),
    });
  });
}


// EPS FAMILY DATA
       if (formData.section2?.epsFamilyData?.length > 0) {
  let yPosition = 696;
  const rowSpacing = 30;
  const textOptions = {
    size: 5,
    font: helveticaFont,
    color: rgb(0, 0, 0),
  };

  formData.section2.epsFamilyData.forEach((familyMember) => {
    page2.drawText(familyMember.name?.toUpperCase() || "", {
      x: 100,
      y: yPosition,
      size: 5,
      font: helveticaFont,
      maxWidth: 100,
      lineHeight: 5,
      color: rgb(0, 0, 0),
    });

    page2.drawText(familyMember.address?.toUpperCase() || "", {
      x: 220,
      y: yPosition,
      size: 5,
      font: helveticaFont,
      maxWidth: 100,
      lineHeight: 5,
      color: rgb(0, 0, 0),
    });

    page2.drawText(familyMember.dob || "", {
      x: 380,
      y: yPosition,
      ...textOptions,
    });

    page2.drawText(familyMember.relationship?.toUpperCase() || "", {
      x: 490,
      y: yPosition,
      ...textOptions,
    });

    yPosition -= rowSpacing;
  });
}

      // EPS NOMINEE DATA
   if (formData.section2?.epsNomineeData?.length > 0) {
  const startY = 435;     
  const rowSpacing = 28;   // space between rows
  const fieldFontSize = 5; // readable font size

  formData.section2.epsNomineeData.slice(0, 3).forEach((nominee, index) => {
    const yPos = startY - index * rowSpacing;

    // === Index number (serial) ===
    // page2.drawText((index + 1).toString(), {
    //   x: 48,
    //   y: yPos,
    //   size: fieldFontSize,
    //   font: helveticaFont,
    //   color: rgb(0, 0, 0),
    // });

    // === Nominee Name and Address ===
    page2.drawText(nominee.nomineeNameAddress?.toUpperCase() || "", {
      x: 50,
      y: yPos,
      size: fieldFontSize,
      font: helveticaFont,
      color: rgb(0, 0, 0),
      maxWidth: 185,
      lineHeight: 8,
    });


    // === Nominee Date of Birth ===
    page2.drawText(nominee.nomineeDob || "", {
      x: 320,
      y: yPos,
      size: fieldFontSize,
      font: helveticaFont,
      color: rgb(0, 0, 0),
    });

    // === Nominee Relationship ===
    page2.drawText(nominee.nomineeRelationship?.toUpperCase() || "", {
      x: 468,
      y: yPos,
      size: fieldFontSize,
      font: helveticaFont,
      color: rgb(0, 0, 0),
    });
  });
}







      page2.drawText(
        formData.section1?.name?.toUpperCase() || "",
        {
          x: 70,
          y: 212,
          size: 8,
          font: helveticaFont,
          color: rgb(0, 0, 0),
        }
      );
      page2.drawText(
        formData.section2?.establishmentDate?.toUpperCase() || "",
        {
          x: 100,
          y: 305,
          size: 8,
          font: helveticaFont,
          color: rgb(0, 0, 0),
        }
      );

      page2.drawText(
        formData.section2?.establishmentDate?.toUpperCase() || "",
        {
          x: 90,
          y: 139,
          size: 8,
          font: helveticaFont,
          color: rgb(0, 0, 0),
        }
      );

      page2.drawText(formData.section2?.epsPlace?.toUpperCase() || "", {
        x: 90,
        y: 163,
        ...textOptions,
      });
      page2.drawText(formData.section2?.destination?.toUpperCase() || "", {
        x: 360,
        y: 69,
        ...textOptions,
      });
    

      // ===== PAGE 3: FORM 11 DECLARATION =====
      page3.drawText(formData.section1?.name?.toUpperCase() || "", {
        x: 365,
        y: 740,
        ...textOptions,
      });

      page3.drawText(formData.section1?.fatherName1?.toUpperCase() || "", {
        x: 365,
        y: 710,
        ...textOptions,
      });

      page3.drawText(formData.section1?.dob?.toUpperCase() || "", {
       x: 400,
            y: 680,
        ...textOptions,
      });

      // if (formData.section1?.dob) {
      //   const dob = moment(formData.section1.dob);
      //   if (dob.isValid()) {
      //     page3.drawText(dob.format("DD/MM/YYYY"), {
      //       x: 400,
      //       y: 680,
      //       ...textOptions,
      //     });
      //   }
      // }

      page3.drawText(formData.section1?.gender || "", {
        x: 405,
        y: 667,
        ...textOptions,
      });

      page3.drawText(formData.section1?.maritalStatus || "", {
        x: 405,
        y: 650,
        ...textOptions,
      });

      page3.drawText(formData.section4?.email || "", {
        x: 395,
        y: 640,
        ...textOptions,
      });

      page3.drawText(formData.section4?.mobile || "", {
        x: 395,
        y: 625,
        ...textOptions,
      });

      if (formData.section4?.previousEPFMember === "Yes") {
        drawCheckmark(page3, 410, 607);
      } else {
        drawCheckmark(page3, 430, 607);
      }

      if (formData?.section1?.isFatherHusband === "Father") {
        drawCheckmark(page3, 120, 717);
      } else {
        drawCheckmark(page3, 220, 717);
      }

      if (formData.section4?.previousEPSMember === "Yes") {
        drawCheckmark(page3, 410, 587);
      } else {
        drawCheckmark(page3, 430, 587);
      }

      if (formData.section4?.previousEPFMember === "Yes") {
        drawCheckmark(page3, 410, 607);
      } else {
        drawCheckmark(page3, 430, 607);
      }

      page3.drawText(formData.section4?.universalKyc || "", {
        x: 395,
        y: 563,
        ...textOptions,
      });

      page3.drawText(formData.section4?.previousPFKyc || "", {
        x: 395,
        y: 535,
        ...textOptions,
      });

      page3.drawText(formData.section4?.previousExitDate || "", {
        x: 400,
        y: 520,
        size: 8,
        font: helveticaFont,
        color: rgb(0, 0, 0),
      });

      page3.drawText(formData.section4?.schemeCertNo || "", {
        x: 400,
        y: 505,
        ...textOptions,
      });
      page3.drawText(formData.section4?.ppoNo || "", {
        x: 400,
        y: 492,
        ...textOptions,
      });

      if (formData.section4?.internationalWorker === "Yes") {
        drawCheckmark(page3, 410, 470);
      } else {
        drawCheckmark(page3, 430, 470);
      }

      page3.drawText(formData.section4?.countryOfOrigin || "", {
        x: 410,
        y: 453,
        ...textOptions,
      });
      page3.drawText(formData.section4?.passportNo || "", {
        x: 410,
        y: 438,
        ...textOptions,
      });

      if (
        formData.section4?.passportValidityFrom &&
        formData.section4?.passportValidityTo
      ) {
        const fromDate = moment(formData.section4.passportValidityFrom);
        const toDate = moment(formData.section4.passportValidityTo);
        if (fromDate.isValid() && toDate.isValid()) {
          page3.drawText(
            `${fromDate.format("DD/MM/YYYY")} to ${toDate.format(
              "DD/MM/YYYY"
            )}`,
            {
              x: 370,
              y: 423,
              ...textOptions,
            }
          );
        }
      }
      page3.drawText(
        `${formData.section4?.accountNoKyc || ""} & ${
          formData.section4?.ifscNoKyc || ""
        }`,
        {
          x: 370,
          y: 390,
          ...textOptions,
        }
      );

      page3.drawText(formData?.section4?.aadhaarNumber || "", {
        x: 400,
        y: 370,
        ...textOptions,
      });

      page3.drawText(formData.section4?.pan || "", {
        x: 400,
        y: 355,
        ...textOptions,
      });

      page3.drawText(
        formData.section2?.establishmentDate?.toUpperCase() || "",
        {
          x: 80,
          y: 249,
          size: 8,
          font: helveticaFont,
          color: rgb(0, 0, 0),
        }
      );

      // if (formData.section2?.establishmentDate) {
      //   const date = moment(formData.section2.establishmentDate);
      //   if (date.isValid()) {
      //     page3.drawText(date.format('DD/MM/YYYY'), {
      //       x: 80,
      //       y: 249,
      //       ...textOptions
      //     });
      //   }
      // }

      page3.drawText(
        formData.section2?.establishmentDate?.toUpperCase() || "",
        {
          x: 110,
          y: 21,
          size: 8,
          font: helveticaFont,
          color: rgb(0, 0, 0),
        }
      );

      // if (formData.section2?.establishmentDate) {
      //   const date = moment(formData.section2.establishmentDate);
      //   if (date.isValid()) {
      //     page3.drawText(date.format('DD/MM/YYYY'), {
      //       x: 110,
      //       y: 21,
      //       ...textOptions
      //     });
      //   }
      // }

      page3.drawText(formData.section2?.epsPlace?.toUpperCase() || "", {
        x: 80,
        y: 237,
        ...textOptions,
      });
      page3.drawText(formData.section1?.name?.toUpperCase() || "", {
        x: 183,
        y: 212,
        size: 6,
        maxWidth: 80,
        lineHeight: 7,
        font: helveticaFont,
        color: rgb(0, 0, 0),
      });

      page3.drawText(
        formData.section2?.establishmentDate?.toUpperCase() || "",
        {
          x: 340,
          y: 212,
          size: 8,
          font: helveticaFont,
          color: rgb(0, 0, 0),
        }
      );

      // page3.drawText(moment(formData.section2?.establishmentDate).format("DD/MM/YYYY") || '', {
      //   x: 340,
      //   y: 212,
      //   size: 8,
      //   font: helveticaFont,
      //   color: rgb(0, 0, 0)
      // });

      // page3.drawImage(signatureImageEmbed, {
      //   x: 360,
      //   y: 30,
      //   width: 130,
      //   height: 27,
      // });
      

      // ===== PAGE 4: GRATUITY FORM F =====
      // page4.drawText(
      //   formData.section5?.establishmentName?.toUpperCase() || "",
      //   {
      //     x: 70,
      //     y: 617,
      //     ...textOptions,
      //   }
      // );

      page4.drawText(
  formData.section5?.establishmentName?.toUpperCase() || "",
  {
    x: 70,
    y: 617,
    size: 8,
    maxWidth: 460,
    lineHeight: 18, 
    font: helveticaFont,
    color: rgb(0, 0, 0),
  }
);

   
      page4.drawText(formData.section5?.name?.toUpperCase() || "", {
        x: 170,
        y: 565,
        ...textOptions,
      });

      page4.drawText(formData.section5?.nominatorName?.toUpperCase() || "", {
        x: 170,
        y: 563,
        ...textOptions,
      });

      if (formData.section5?.exclusionNoticeDate) {
        const date = moment(formData.section5.exclusionNoticeDate);
        if (date.isValid()) {
          page4.drawText(date.format("DD/MM/YYYY"), {
            x: 420,
            y: 364,
            ...textOptions,
          });
        }
      }

      if (formData.section5?.gratuityNomineeData?.length > 0) {
        formData.section5.gratuityNomineeData.forEach((nominee, index) => {
          if (index < 5) {
            const yPos = 174 - index * 18;
            page4.drawText(nominee.name?.toUpperCase() || "", {
              x: 90,
              y: yPos + 4,
              size: 5,
              lineHeight:7,
              maxWidth:180,
        font: helveticaFont,
        color: rgb(0, 0, 0),
            });
            page4.drawText(nominee.relationship?.toUpperCase() || "", {
              x: 320,
              y: yPos,
              ...textOptions,
            });
            page4.drawText(nominee.age || "", {
              x: 400,
              y: yPos,
              ...textOptions,
            });
            page4.drawText(nominee.proportion || "", {
              x: 480,
              y: yPos,
              ...textOptions,
            });
          }
        });
      }

      // ===== PAGE 5: STATEMENT AND WITNESSES =====
      page5.drawText(formData.section1?.name?.toUpperCase() || "", {
        x: 190,
        y: 740,
        ...textOptions,
      });

      if (formData.section1?.gender) {
        page5.drawText(formData.section1.gender?.toUpperCase() || "", {
          x: 120,
          y: 724,
          ...textOptions,
        });
      }

      page5.drawText(formData.section3?.religion?.toUpperCase() || "", {
        x: 120,
        y: 705,
        ...textOptions,
      });

      if (formData.section1?.maritalStatus) {
        page5.drawText(formData.section1.maritalStatus?.toUpperCase() || "", {
          x: 270,
          y: 687,
          ...textOptions,
        });
      }

      page5.drawText(formData.section3?.department?.toUpperCase() || "", {
        x: 280,
        y: 670,
        ...textOptions,
      });

      page5.drawText(formData.section3?.postWithTicketNo || "", {
        x: 280,
        y: 650,
        ...textOptions,
      });

      page5.drawText(
        formData.section2?.establishmentDate?.toUpperCase() || "",
        {
          x: 180,
          y: 633,
          size: 8,
          font: helveticaFont,
          color: rgb(0, 0, 0),
        }
      );

      // page5.drawText(
      //   moment(formData.section5?.exclusionNoticeDate).format('DD/MM/YYYY') || '',
      //   {
      //     x: 180,
      //     y: 633,
      //     ...textOptions
      //   }
      // );

      page5.drawText(formData.section3?.village?.toUpperCase() || "", {
        x: 120,
        y: 597,
        ...textOptions,
      });

      page5.drawText(formData.section3?.thana?.toUpperCase() || "", {
        x: 280,
        y: 597,
        ...textOptions,
      });
      page5.drawText(formData.section3?.subDivision?.toUpperCase() || "", {
        x: 460,
        y: 597,
        ...textOptions,
      });
      page5.drawText(formData.section3?.postOffice?.toUpperCase() || "", {
        x: 130,
        y: 578,
        ...textOptions,
      });
      page5.drawText(formData.section3?.district?.toUpperCase() || "", {
        x: 280,
        y: 578,
        ...textOptions,
      });
      page5.drawText(formData.section3?.state?.toUpperCase() || "", {
        x: 420,
        y: 578,
        ...textOptions,
      });

      page5.drawText(
        formData.section2?.establishmentDate?.toUpperCase() || "",
        {
          x: 100,
          y: 482,
          size: 8,
          font: helveticaFont,
          color: rgb(0, 0, 0),
        }
      );

      // page5.drawText(
      //   moment(formData.section5?.exclusionNoticeDate).format('DD/MM/YYYY') || '',
      //   {
      //     x: 100,
      //     y: 482,
      //     ...textOptions
      //   }
      // );

      page5.drawText(formData.section2?.epsPlace?.toUpperCase() || "", {
        x: 100,
        y: 522,
        ...textOptions,
      });

      page5.drawText(
        formData.section3?.witness1NameAddress?.toUpperCase() || "",
        {
          x: 80,
          y: 370,
          ...textOptions,
        }
      );
      page5.drawText(
        formData.section3?.witness2NameAddress?.toUpperCase() || "",
        {
          x: 80,
          y: 335,
          ...textOptions,
        }
      );

      page5.drawText(
        formData.section2?.establishmentDate?.toUpperCase() || "",
        {
          x: 90,
          y: 262,
          size: 8,
          font: helveticaFont,
          color: rgb(0, 0, 0),
        }
      );

      // if (formData.section2?.establishmentDate) {
      //   const date = moment(formData.section2.establishmentDate);
      //   if (date.isValid()) {
      //     page5.drawText(date.format('DD/MM/YYYY'), {
      //       x: 90,
      //       y: 262,
      //       ...textOptions
      //     });
      //   }
      // }

      page5.drawText(formData.section2?.epsPlace?.toUpperCase() || "", {
        x: 90,
        y: 280,
        ...textOptions,
      });

      page5.drawText(
        formData.section2?.establishmentDate?.toUpperCase() || "",
        {
          x: 90,
          y: 112,
          size: 8,
          font: helveticaFont,
          color: rgb(0, 0, 0),
        }
      );

      // if (formData.section2?.establishmentDate) {
      //   const date = moment(formData.section2.establishmentDate);
      //   if (date.isValid()) {
      //     page5.drawText(date.format('DD/MM/YYYY'), {
      //       x: 90,
      //       y: 112,
      //       ...textOptions
      //     });
      //   }
      // }

      page6.drawText(
        formData.section2?.establishmentDate?.toUpperCase() || "",
        {
          x: 90,
          y: 667,
          size: 8,
          font: helveticaFont,
          color: rgb(0, 0, 0),
        }
      );

      // if (formData.section2?.establishmentDate) {
      //   const date = moment(formData.section2.establishmentDate);
      //   if (date.isValid()) {
      //     page6.drawText(date.format('DD/MM/YYYY'), {
      //       x: 90,
      //       y: 667,
      //       ...textOptions
      //     });
      //   }
      // }

      const pdfBytes = await pdfDoc.save();
      return new Blob([pdfBytes], { type: "application/pdf" });
    } catch (error) {
      console.error("Error filling PDF form:", error);
      throw error;
    }
  };

  const handlePreview = async () => {
    setPreviewVisible(true);
    setLoadingPreview(true);
    try {
      const blob = await fillPdfForm();
      const url = URL.createObjectURL(blob);
      setPdfUrl(url);
    } catch (error) {
      console.error("Error generating preview:", error);
    } finally {
      setLoadingPreview(false);
    }
  };

  const handleDownload = async () => {
    setLoadingDownload(true);
    try {
      const blob = await fillPdfForm();
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `Compliance-Forms-${formData.user_id || "unknown"}.pdf`;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      }, 100);
    } catch (error) {
      console.error("Error downloading PDF:", error);
    } finally {
      setLoadingDownload(false);
    }
  };

  const handleClosePreview = () => {
    setPreviewVisible(false);
    if (pdfUrl) {
      URL.revokeObjectURL(pdfUrl);
      setPdfUrl(null);
    }
  };

  const handleUploadToS3 = async () => {
    try {
      message.loading({
        content: "Saving form...",
        key: "upload",
        duration: 0,
      });

      // 1. Generating the PDF blob
      const pdfBlob = await fillPdfForm();

      // 2. Creating File object
      const pdfFile = new File(
        [pdfBlob],
        `compliance,_Form_${formData.user_id}.pdf`,
        {
          type: "application/pdf",
        }
      );

      const resultAction = await dispatch(
        uploadPdfToS3({
          user_id: formData.user_id,
          file: pdfFile,
          file_type: "compliance",
          jwtBearer,
        })
      );

      if (uploadPdfToS3.fulfilled.match(resultAction)) {
        message.success({ content: "Form Saved successfully!", key: "upload" });
        // if (resultAction.payload.url) {
        //   message.info(`PDF available at: ${resultAction.payload.url}`);
        // }
      } else {
        throw new Error(resultAction.error.message || resultAction.payload);
      }
    } catch (error) {
      console.error("Upload failed:", error);
      message.error({
        content: error.message || "Failed to upload PDF",
        key: "upload",
      });
    }
  };

  return (
    <>
      <Space style={{ display: "flex", justifyContent: "flex-end" }}>
        {/* <Button
          type="default"
          onClick={handlePreview}
          icon={loadingPreview ? <Spin /> : <FaEye />}
          disabled={loadingPreview || loadingDownload}
          style={{ marginRight: 8 }}
        >
          {loadingPreview ? "Generating Preview..." : "Preview PDF"}
        </Button> */}
        <Button
          type="primary"
          onClick={handleDownload}
          icon={loadingDownload ? <Spin /> : <FaFileDownload />}
          disabled={loadingDownload || loadingPreview}
        >
          {loadingDownload ? "Preparing Download..." : "Download PDF"}
        </Button>

        {formData?.is_section1_completed === true &&
          formData?.is_section2_completed === true &&
          formData?.is_section3_completed === true &&
          formData?.is_section4_completed === true &&
          formData?.is_section5_completed === true && (
            <Button
              type="primary"
              onClick={handleUploadToS3}
              icon={loadingUpload ? <Spin /> : <FaSave />}
              disabled={loadingUpload || loadingDownload}
              style={{ backgroundColor: "#1890ff", borderColor: "#1890ff" }}
            >
              {loadingUpload ? "Saving..." : "Save"}
            </Button>
          )}
        {/* 
        {
          formData?.is_section1_completed === true &&
          formData?.is_section2_completed === true &&
          formData?.is_section3_completed === true &&
          formData?.is_section4_completed === true &&
          formData?.is_section5_completed === true &&
          !formData?.compliance_pdf && (
            <Button
              type="primary"
              onClick={handleUploadToS3}
              icon={loadingUpload ? <Spin /> : <FaSave />}
              disabled={loadingUpload || loadingDownload}
              style={{ backgroundColor: '#1890ff', borderColor: '#1890ff' }}
            >
              {loadingUpload ? 'Saving...' : 'Save'}
            </Button>
          )
        } */}
      </Space>

      <Modal
        title="Compliance Forms Preview"
        open={previewVisible}
        onCancel={handleClosePreview}
        footer={null}
        width="90%"
        style={{ top: 20 }}
        destroyOnClose
      >
        {loadingPreview ? (
          <div style={{ textAlign: "center", padding: "50px" }}>
            <Spin size="large" />
            <p>Generating PDF preview...</p>
          </div>
        ) : pdfUrl ? (
          <iframe
            src={pdfUrl}
            width="100%"
            height="800px"
            style={{ border: "none" }}
            title="Compliance Forms PDF Preview"
          />
        ) : (
          <div style={{ textAlign: "center", padding: "50px" }}>
            <p>Failed to generate PDF preview</p>
          </div>
        )}
      </Modal>
    </>
  );
};

export default PdfCompliance;
